import LxcError from "~/core/models/LxcError.class";
import type { UseFetchParameters } from "~/core/models/UseFetchParameters.type";
import type { DtwinModelUiConfig } from "~/modules/dtwin/models/DtwinModelUiConfig.interface";
import dtwinsService from "~/modules/dtwin/services/dtwin.service";

export function useFetchDtwinModelUIConfigs({
  organizationCode,
}: UseFetchParameters) {
  const results: Ref<DtwinModelUiConfig[] | undefined> = ref();
  const error: Ref<LxcError | undefined> = ref();
  const isLoading: Ref<boolean> = ref(false);

  async function fetchAll() {
    isLoading.value = true;

    const response =
      await dtwinsService.getOrganizationAllDeviceModelUiConfigs(
        organizationCode,
      );
    if (LxcError.check(response)) {
      error.value = response;
    } else {
      results.value = response;
    }

    isLoading.value = false;
  }

  return {
    results,
    isLoading,
    error,
    fetchAll,
  };
}
